import * as React from "react";
import {
    ImportSvgResolverDialog,
    PreviewPanelDialog, ScriptEditor
} from '..';
import { SvgAnnotationsWindow } from '@/components/svg-annotations';
import { TagEditor } from '@/components/_PanelDesigner/pdTagEditor';
import { SvgSourceEditor } from "@/components/_Dialogs/svg-source-editor";

type DialogType = "importSvgResolver"
    | "previewPanel"
    | "tagEditor"
    | "svgSourceEditor"
    | "scriptEditor";

interface IDialogGroup {
    importSvgResolver: React.RefObject<ImportSvgResolverDialog>;
    previewPanel: React.RefObject<PreviewPanelDialog>;
    tagEditor: React.RefObject<TagEditor>;
    svgSourceEditor: React.RefObject<SvgSourceEditor>;
    scriptEditor: React.RefObject<ScriptEditor>;
}


export class DialogWrapper extends React.Component {
    private static _instance: DialogWrapper;
    public static get Instance() { return DialogWrapper._instance; }

    public dialogs: IDialogGroup = {
        importSvgResolver: React.createRef(),
        previewPanel: React.createRef(),
        tagEditor: React.createRef(),
        svgSourceEditor: React.createRef(),
        scriptEditor: React.createRef(),
    }

    public static GetDialog<T = any>(dialogType: DialogType) {
        return DialogWrapper.Instance.dialogs[dialogType].current as unknown as T;
    }

    public componentDidMount() {
        DialogWrapper._instance = this;
    }

    public render() {
        return (
            <>
                <SvgAnnotationsWindow />
                <ImportSvgResolverDialog ref={this.dialogs.importSvgResolver} />
                <PreviewPanelDialog ref={this.dialogs.previewPanel} />
                <TagEditor ref={this.dialogs.tagEditor} />
                <SvgSourceEditor ref={this.dialogs.svgSourceEditor} />
                <ScriptEditor ref={this.dialogs.scriptEditor} />
            </>
        );
    }
}
